































































































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { AppModule } from '@/store/modules/app';
import WorkerBookingConfirmationConfirmDecline from '@/components/AnonWorkers/WorkerBookingConfirmationConfirmDecline.vue';
import { VuetifyConfirmObject } from "vuetify-confirm";
import UpdateAnonWorkerBookingConfirmationRequest from '@/models/AnonBookingRoleWorkers/UpdateAnonWorkerBookingConfirmationRequest';
import AnonBookingRoleWorkerDto from '@/models/AnonBookingRoleWorkers/AnonBookingRoleWorkerDto';
import BookingRoleWorkerShiftStatus from '@/components/BookingRoleWorkerShifts/Display/BookingRoleWorkerShiftStatus.vue';

@Component({
  name: 'BookingConfirmation',
  components: { WorkerBookingConfirmationConfirmDecline, BookingRoleWorkerShiftStatus }
})
export default class BookingConfirmation extends GiganautVue {

  get bookingConfirmation(): AnonBookingRoleWorkerDto {
    return WorkerAnonModule.bookingConfirmation;
  }

  get loading() {
    return WorkerAnonModule.loading;
  }

  get isConfirmationSubmitted() {
      return WorkerAnonModule.isBookingConfirmationSubmitted;
  }
}
